<template>
  <div class="text-center pa-4 pt-0" style="">
    <v-row class="w-100 ma-0">
        <v-col cols="6" class="pt-0 pr-0">
          <h3 style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;">Vault</h3>
        </v-col>
        <v-col cols="6" class="pa-0 text-right">
      <v-btn class="mb-2 btn-soft-success" style="z-index:99999; color: white;" @click="dialogDocUpload = true">
        <v-icon class="mr-2">mdi-plus</v-icon> Upload new file
      </v-btn>
        </v-col>
      </v-row>
    <div v-if="allDoc && allDoc.documents" class="hover-elevation bg-white v-card v-sheet theme--light" style="box-shadow: none; border-radius: 24px;">
                <v-row class="tableHead w-100 ma-0">
                    <v-col cols="4" class="pa-0 text-left">
                        Document
                    </v-col>
                    <v-col cols="3" class="pa-0 text-left">Company</v-col>
                    <v-col cols="4" class="pa-0 text-left">Uploaded
                        <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">By</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">Date</small>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 text-left">Download</v-col>
                </v-row>
                <div class="log" style="height: 60vh; overflow-y: auto;">
                    <v-row class="w-100 ma-0 text-left" style=" border-top: 1px solid rgb(233, 235, 236) !important;" v-for="(log, l) in allDoc.documents" :key="l">
                        <v-col cols="4">
                            {{ log.title }}<br>
                            <small>{{ log.description }}</small>
                        </v-col>
                        <v-col cols="3">
                            {{ log.company.company_name }}
                        </v-col>
                        <v-col cols="4">
                            <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ log.created_by.display_name }}</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ moment(log.created_at).format('DD MMM YYYY') }}</small>
                            </v-col>
                        </v-row>
                            
                        </v-col>
                        <v-col>
                            <v-btn @click="downloadFile(log.document_url)" text icon class="btn-soft-success">
                                <v-icon>mdi-file-download</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
  <div v-else class="firstNew" style="background: white; border-radius:24px; padding: 24px;text-align:left;margin-bottom:24px;">
          <p class="text-center" style="    color: rgb(135, 136, 136);
    padding-top: 140px;
    margin: 0px;
    text-align: center !important;">No documents available</p>
        </div>
        <v-dialog
      v-model="dialogDocUpload"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span style="color: rgb(13, 13, 96); font-size: 1.5rem !important; font-weight: 800 !important; text-align: left;">Upload document</span>
        </v-card-title>
        <v-card-text style="max-height:450px; overflow-y:auto;">
            <v-container class="documentAdd">
            <v-row class="mt-2">
                <v-col class="pb-0" cols="12">
                    <label>Document title*</label>
                    <v-text-field
                    v-model="doc.title"
                    name="company_name"
                    placeholder="Enter your company name"
                    outlined  hide-details
                    :rules="nameRules"
                    required
                    dense
                    ></v-text-field>
                    </v-col>
                    <v-col class="pb-0" cols="12">
                    <label>Document description*</label>
                    <v-text-field
                    v-model="doc.description"
                    name="company_name"
                    placeholder="Enter your company name"
                    outlined 
                    :rules="nameRules"
                    required hide-details
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="text-center pb-0 pt-3">
                    <input v-if="!imageData"
                    id="upload"
                    class="file-upload__input"
                    type="file" accept="*" name="file-upload"
                    @input="previewImage"
                    >
                    <p v-if="imageData" class="fileName">{{doc.name}} <v-icon @click="changeLogo()">mdi-window-close</v-icon></p>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="closeDialog()" text>Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="uploadDoc()" :loading="loadingUpload" class="btn-soft-success">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from 'axios';
import moment from 'moment';
import 'sweetalert2/dist/sweetalert2.min.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-scroll';
import VueSweetalert2 from 'vue-sweetalert2';
import { mapState } from 'vuex';
import addCompany from './dialogs/AddCompany';
dayjs.extend(relativeTime);
var count = 0;

  Vue.use(VueSweetalert2);
  am4core.useTheme(am4themes_animated);
  export default {
    name: 'Dashboard',

    components: {
      axios,
      InfiniteLoading,
      addCompany,
      dayjs
    },

    data: () => ({
      moment: moment,
      loadingUpload: false,
      dashboardData: null,
      allDoc: null,
      dialogDocUpload: false,
      editView: false,
      imageData: '',
      errorList: '',
      doc: {}
    }),
    methods: {
      closeDialog () {
        this.dialogDocUpload = false;
        this.doc = {};
      },
        changeLogo () {
        this.imageData = '';
        this.errorList = '';
      },
      downloadFile (url) {
        if (url) {
          window.open(url);
        } else {
          this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Download file access denied!'
          });
        }
    },
      previewImage(event) {
        let input = event.target;
        if (input.files && input.files[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            if (input.files[0].size < 2000000) {
              this.imageData = e.target.result;
              this.doc.document = input.files[0];
              this.doc.name = input.files[0].name;
            } else {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: 'Image size cannot be more then 2MB!'
              });
            }
          }
          reader.readAsDataURL(input.files[0]);
        }
      },
    uploadDoc () {
        this.loading = true;
        this.loadingUpload = true;
        const formData = new FormData();
        formData.append('company', this.$route.query.cid);
        formData.append('title', this.doc.title);
        formData.append('description', this.doc.description);
        formData.append('document', this.doc.document);
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.post(`${process.env.VUE_APP_API_URL}company/vault`, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
        }).then((response) => {
          this.loading = false;
          if (response && response.data) {
            this.loadingUpload = false;
            this.dialogDocUpload = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Document uploaded successfully!'
            });
            this.getCompanyDocs(this.$route.query.cid);
          }
        }).catch((err) => {
          this.loading = false;
          console.log(err.response);
          if (err.response && err.response.data) {
            this.errorList = err.response.data.error;
          }
          if (err.response.status && err.response.status === 429 && err.response.data) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
        getCompanyDocs(id) {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/vault?company_id=${id}`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.allDoc = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
    },
    mounted () {
      this.getCompanyDocs(this.$route.query.cid);
    }
  }
</script>
<style lang="scss" >
.documentAdd {
  .file-upload__input {
    border-radius: 24px !important;;
  }
    input[type=file] {
        width:100%;
    }
    input[type=file]:before {
    content: 'Drag and drop or Click \A to select document.';
    white-space: pre-wrap;
    vertical-align: middle;
    text-align: center;
    font-size: 1em;
    line-height: 1.5;
    display: inline-block;
    background: #f1f1f1;
    width:100%;
    border-radius: 24px !important;
    padding: 45px 34px;
    font-family: Helvetica, Arial, sans-serif;
    }

    input[type=file]::-webkit-file-upload-button {
    visibility: hidden;
    }
}
.filterDrawer .v-icon.v-icon {
  font-size: 14px !important;
}
.filterDrawer .v-input--selection-controls {
  margin-top: 0px !important;
}
.image-preview:hover .overlay1 {
  display: block;
}
.image-preview:hover .overlay2 {
  display: block;
}
.overlay1 {
  display: none;
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  width: 100%;
  cursor:pointer;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 10px 0;
  text-align: center;
}
.overlay2 {
  display: none;
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  width: 100%;
  cursor:pointer;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 10px 15px 15px 15px;
  text-align: center;
}
input[type=file] {
  cursor: pointer;
  width: 130px;
  height: 130px;
  padding:10px;
  border-radius: 10px;
  overflow: hidden;
  background: #f1f1f1;
}

input[type=file]:before {
  content: 'Drag and drop \A or \A click to add \A avatar';
  vertical-align: middle;
  white-space: pre-wrap;
  text-align: center;
  font-size: .8em;
  display: inline-block;
  background: #f1f1f1;
  padding: 20% 10px;
  font-family: Helvetica, Arial, sans-serif;
}

input[type=file]::-webkit-file-upload-button {
  visibility: hidden;
}
.heading {
  font-size: 16px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}
.mainBox {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
  height: 16rem;
  transition: 0.5s;
  -webkit-transition: 0.5s;
  text-align: center;
}
.v-btn--active {
  background-color: #050550 !important;
}
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
#chartdiv1 {
  height: 360px;
  width:100%;;
}

.primary--text {
  color: #050550 !important;
}
#chartdiv {
  width: 100%;
  height: 210px;
  
}
.headingprofile {
  text-align: left;
  h2 {
    color: #263238;
    font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.firstNew::before {
    background: #fff none repeat scroll 0 0;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.8;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
}
.overlay {
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.3); /* Black see-through */
  width: 100%;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 72% 0 20% 0;
  text-align: center;
}
::-webkit-scrollbar-track
{
	// -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #ffffff;
}

::-webkit-scrollbar
{
	width: 12px;
	background-color: #ffffff;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #ccc;
}
.v-timeline-item__inner-dot {
  .v-icon {
    color: #263238;
  }
}
.filterButton {
  text-transform: capitalize;
  border-radius:6px;
  box-shadow: none !important;
    color: #10b981 !important;
    background: #daf4f0 !important;
    border-color: transparent;
}
.filterButton:hover {
  box-shadow: none !important;
  color: white !important;
  background: #10b981 !important;
  border-color: transparent !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.v-btn-toggle--group > .v-btn.v-btn {
  margin-left: 0px !important;
  margin-right:0px !important;
  border-color: #d7d7d7 !important;
}
.v-btn-toggle > .v-btn.v-btn--active {
  background-color: #10b981 !important;
  color: white !important;

}
.hover:hover {
  background-color: #10b981;
    color: white;
    position: relative;
    padding: 10px;
    display:flex;
}
.hover:hover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: #10b981;
}
.toggleButton {
    text-transform: capitalize; 
}
.responsive-avatar {
    width: 100%;
    height: 100%;
    max-width: 140px;
    max-height: 140px;
    min-width: 80px;
    min-height: 80px;
}

.responsive-avatar img {
    width: 100%;
    height: auto;
    border-radius: 50%;
}
</style>
